<template>
    <div class="home">
        <FormComponent/>
    </div>
</template>

<script>
    // @ is an alias to /src
    import FormComponent from '@/components/FormComponent.vue'

    export default {
        name: 'home',
        components: {
            FormComponent
        }
    }
</script>
